import {
  Box,
  Button,
  Link,
  Pagination,
  Table,
  Typography,
} from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import Colors from "@constants/Colors";
import styled from "styled-components";

export const StyledRootBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  padding: 8px !important;
  gap: 8px !important;
  background: ${Colors.white} !important;
  border: 1px solid ${Colors.neutral_gray_300} !important;
  border-radius: 12px !important;
  min-height: inherit;
`;

export const StyledBox = styled(Box)`
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 8px !important;
  overflow-x: scroll;
`;

export const StyledTypographyTitle = styled(Typography)`
  font-family: "Ringside Regular-Bold" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: ${Colors.neutralblack};
`;

export const StyledButton = styled(Button)`
  text-transform: capitalize !important;
  gap: 4px !important;
  color: ${Colors.primary} !important;
  font-family: "Ringside Regular-Bold" !important;
  font-size: 14px !important;
  line-height: 20px !important;
  height: 40px !important;
`;

export const StyledHeadTableCell = styled(TableCell)`
  background-color: ${Colors.neutral_gray_100} !important;
  padding: 10px 12px 9px !important;
  cursor: pointer !important;
`;

export const StyledBodyTableCell = styled(TableCell)`
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 10px 12px 9px !important;
`;

export const StyledTable = styled(Table)`
  border-radius: 12px !important;
  border: 1px solid ${Colors.neutral_gray_300} !important;
  box-shadow: ${Colors.Elevation_2} !important;
  border-radius: 4px !important;
`;

export const StyledButtonBox = styled(Box)<{
  pagination: boolean | undefined | string;
}>`
  display: flex !important;
  flex-direction: column !important;
  align-items: ${({
    pagination,
  }: {
    pagination: boolean | undefined | string;
  }) => (pagination ? "center" : "flex-end")} !important;
  padding: 0px !important;
`;

export const StyledHeadBox = styled(Box)`
  .MuiButton-root {
    font-family: "Ringside Regular-Bold" !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: ${Colors.black};
    letter-spacing: 0;
    text-transform: none;
    padding: 0px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    &:hover {
      background-color: transparent;
    }
  }
`;

export const StyledPagination = styled(Pagination)`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  .Mui-selected {
    color: ${Colors.primary} !important;
    background-color: ${Colors.neutral_gray_100} !important;
    border: 1.5px solid ${Colors.primary} !important;
  }
`;

export const StyledTableRow = styled(TableRow)`
  height: 40px !important;
`;

export const StyledLink = styled(Link)`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
`;
